export const styles = {
  outerContainer: "min-h-screen bg-gray-50 md:bg-white",
  innerContainer: "min-h-screen w-full flex flex-col bg-white shadow-lg md:shadow-none",
  titleSection: "bg-primary-darkest flex h-20 w-full items-center justify-center",
  titleText: "text-[32px] font-bold text-white",
  contentContainer: "flex-1 flex flex-col",
  footer: "mt-auto w-full"
} as const

export const colors = {
  backgroundGray: 'bg-gray-50',
  backgroundWhite: 'bg-white',
  titleBackground: 'bg-primary-darkest',
  titleText: 'text-white'
} as const

export const breakpoints = {
  mobile: 'md:',
  tablet: 'lg:',
  desktop: 'xl:'
} as const
